/* ============================================================
   Essaints Bundle Widget — v3.0
   Mix & match: each slot picks its own color + size.
   Styled to match Horizon theme exactly.
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. BUNDLE CONFIGS ────────────────────────────────────── */
  const CONFIGS = {
    'perfect-fit': {
      label: 'Perfect Fit T-Shirt',
      tiers: [
        { qty: 1, price: 26.00, badge: null,              highlight: false },
        { qty: 2, price: 23.00, badge: 'Most popular ⚡', highlight: true  },
        { qty: 4, price: 20.00, badge: 'Best savings 🏆', highlight: false }
      ]
    },
    
    'linen-pants': {
      label: 'Linen Pants',
      tiers: [
        { qty: 1, price: 36.00, badge: null,              highlight: false },
        { qty: 2, price: 33.00, badge: 'Most popular ⚡', highlight: true  },
        { qty: 3, price: 31.00, badge: 'Best savings 🏆', highlight: false }
      ]
    }
  };

  /* ── 2. DETECT PRODUCT TYPE ───────────────────────────────── */
  function detectType() {
    const text = [
      document.querySelector('h1')?.textContent || '',
      document.title,
      window.location.pathname
    ].join(' ').toLowerCase();
    if (/linen.pants|linen-pants/.test(text))             return 'linen-pants';
    if (/perfect.fit|regular.fit|perfect-fit/.test(text)) return 'perfect-fit';
    if (/oversiz/.test(text))                              return 'oversized';
    return null;
  }

  /* ── 3. LOAD PRODUCT VARIANTS ─────────────────────────────── */
  function loadProduct() {
    return fetch(window.location.pathname.split('?')[0] + '.js')
      .then(r => r.json());
  }

  /* ── 4. STYLES (matching Horizon exactly) ─────────────────── */
  function injectStyles() {
    if (document.getElementById('esb-styles')) return;
    const s = document.createElement('style');
    s.id = 'esb-styles';
    s.textContent = `
      /* ── WRAPPER ── */
      .esb-wrap {
        margin: 0 0 20px;
        font-family: Inter, -apple-system, sans-serif;
        font-size: 14px;
        color: rgba(0,0,0,0.81);
        border: 0.8px solid rgb(230,230,230);
        border-radius: 14px;
        overflow: hidden;
      }

      /* ── HEADER ── */
      .esb-head {
        padding: 14px 16px 12px;
        border-bottom: 0.8px solid rgb(230,230,230);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(0,0,0,0.81);
      }

      /* ── TIERS ── */
      .esb-tiers {
        padding: 12px 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        border-bottom: 0.8px solid rgb(230,230,230);
      }
      .esb-tier {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 11px 13px;
        border-radius: 10px;
        border: 0.8px solid rgb(230,230,230);
        background: #fff;
        cursor: pointer;
        transition: border-color 0.15s, background 0.15s;
        position: relative;
        overflow: hidden;
      }
      .esb-tier:hover { border-color: rgba(0,0,0,0.3); }
      .esb-tier.esb-selected {
        border-color: rgba(0,0,0,0.81);
        background: rgba(0,0,0,0.02);
      }
      .esb-tier.esb-hot { background: #fffdf4; }
      .esb-badge {
        display: inline-block;
        background: rgba(0,0,0,0.81);
        color: #fff; font-size: 10px; font-weight: 600;
        padding: 3px 10px;
        border-radius: 99px;
        letter-spacing: 0.03em;
        margin-top: 6px;
        margin-left: 26px;
      }
      .esb-tier.esb-hot .esb-badge { background: #b8860b; }
      .esb-radio {
        width: 16px; height: 16px; border-radius: 50%;
        border: 1px solid rgb(200,200,200);
        flex-shrink: 0; transition: all 0.15s;
        display: flex; align-items: center; justify-content: center;
      }
      .esb-tier.esb-selected .esb-radio {
        border-color: rgba(0,0,0,0.81);
        background: rgba(0,0,0,0.81);
      }
      .esb-tier.esb-selected .esb-radio::after {
        content: ''; width: 6px; height: 6px;
        border-radius: 50%; background: #fff;
      }
      .esb-tier-mid { flex: 1; }
      .esb-tier-qty {
        font-size: 13px; font-weight: 500;
        color: rgba(0,0,0,0.81);
      }
      .esb-tier-save { font-size: 11px; color: #1D9E75; margin-top: 2px; }
      .esb-tier-right { text-align: right; }
      .esb-tier-total { font-size: 14px; font-weight: 500; }
      .esb-tier-orig { font-size: 11px; color: #bbb; text-decoration: line-through; }

      /* ── SLOTS ── */
      .esb-slots { padding: 12px 16px; border-bottom: 0.8px solid rgb(230,230,230); }
      .esb-slot {
        margin-bottom: 14px;
        padding-bottom: 14px;
        border-bottom: 0.8px solid rgb(230,230,230);
      }
      .esb-slot:last-child { margin-bottom: 0; padding-bottom: 0; border-bottom: none; }
      .esb-slot-title {
        font-size: 12px; font-weight: 500;
        color: rgba(0,0,0,0.5);
        letter-spacing: 0.04em;
        text-transform: uppercase;
        margin-bottom: 10px;
      }
      .esb-opt-label {
        font-size: 13px; font-weight: 400;
        color: rgba(0,0,0,0.6);
        margin-bottom: 6px;
        display: flex; align-items: center; gap: 6px;
      }
      .esb-opt-val {
        font-weight: 500;
        color: rgba(0,0,0,0.81);
      }
      .esb-btns {
        display: flex; flex-wrap: wrap; gap: 6px;
        margin-bottom: 10px;
      }
      .esb-opt-btn {
        padding: 7px 14px;
        font-size: 13px;
        border-radius: 10px;
        border: 0.8px solid rgb(230,230,230);
        background: #fff;
        cursor: pointer;
        transition: all 0.15s;
        color: rgba(0,0,0,0.81);
        font-family: inherit;
        position: relative;
      }
      .esb-opt-btn:hover { border-color: rgba(0,0,0,0.4); }
      .esb-opt-btn.esb-opt-selected {
        border-color: rgba(0,0,0,0.81);
        background: rgba(0,0,0,0.81);
        color: #fff;
      }
      .esb-opt-btn.esb-unavail {
        opacity: 0.35;
        cursor: not-allowed;
        text-decoration: line-through;
      }

      /* ── FOOTER ── */
      .esb-foot { padding: 14px 16px; }
      .esb-atc {
        width: 100%;
        padding: 14px;
        font-size: 15px;
        font-weight: 500;
        background: rgb(23,29,66);
        color: #fff;
        border: none;
        border-radius: 14px;
        cursor: pointer;
        transition: opacity 0.15s;
        font-family: inherit;
        letter-spacing: 0.01em;
      }
      .esb-atc:hover { opacity: 0.88; }
      .esb-atc:disabled { opacity: 0.4; cursor: not-allowed; }
      .esb-atc.esb-adding { opacity: 0.6; cursor: wait; }
      .esb-atc.esb-done { background: #1D9E75; }
      .esb-note {
        font-size: 11px; color: rgba(0,0,0,0.4);
        text-align: center; margin-top: 8px;
      }
    `;
    document.head.appendChild(s);
  }

  /* ── 5. STATE ─────────────────────────────────────────────── */
  let state = {
    tierIdx: 1, // default: most popular (index 1)
    slots: [],  // array of { color: null, size: null } per slot
    adding: false
  };

  let productData   = null;
  let currentConfig = null;
  let widgetEl      = null;

  /* ── 6. HELPERS ───────────────────────────────────────────── */
  function fmt(n) {
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function findVariant(color, size) {
    if (!productData) return null;
    return productData.variants.find(v =>
      v.option1 === color && v.option2 === size
    ) || null;
  }

  function isAvailable(color, size) {
    const v = findVariant(color, size);
    return v ? v.available : false;
  }

  function allSlotsComplete() {
    return state.slots.every(s => s.color && s.size);
  }

  /* ── 7. RENDER TIERS ──────────────────────────────────────── */
  function renderTiers(config) {
    const wrap = document.createElement('div');
    wrap.className = 'esb-tiers';

    config.tiers.forEach((tier, i) => {
      const base   = config.tiers[0].price;
      const saving = base - tier.price;

      const t = document.createElement('div');
      t.className = 'esb-tier' +
        (i === state.tierIdx ? ' esb-selected' : '') +
        (tier.highlight ? ' esb-hot' : '');

      if (tier.badge) {
        const b = document.createElement('div');
        b.className = 'esb-badge';
        b.textContent = tier.badge;
        t.appendChild(b);
      }

      const radio = document.createElement('div');
      radio.className = 'esb-radio';

      const mid = document.createElement('div');
      mid.className = 'esb-tier-mid';

      const qty = document.createElement('div');
      qty.className = 'esb-tier-qty';
      qty.textContent = tier.qty + (tier.qty === 1 ? ' item' : ' items') + ' — ' + fmt(tier.price) + ' each';
      mid.appendChild(qty);

      if (saving > 0) {
        const sav = document.createElement('div');
        sav.className = 'esb-tier-save';
        sav.textContent = 'Save ' + fmt(saving * tier.qty);
        mid.appendChild(sav);
      }
      t.appendChild(mid);

      const right = document.createElement('div');
      right.className = 'esb-tier-right';

      const tot = document.createElement('div');
      tot.className = 'esb-tier-total';
      tot.textContent = fmt(tier.price * tier.qty);
      right.appendChild(tot);

      if (saving > 0) {
        const orig = document.createElement('div');
        orig.className = 'esb-tier-orig';
        orig.textContent = fmt(base * tier.qty);
        right.appendChild(orig);
      }
      t.appendChild(right);

      t.addEventListener('click', () => {
        state.tierIdx = i;
        // Reset slots for new quantity
        const qty = config.tiers[i].qty;
        state.slots = Array.from({ length: qty }, () => ({ color: null, size: null }));
        rerender();
      });

      wrap.appendChild(t);
    });

    return wrap;
  }

  /* ── 8. RENDER SLOTS ──────────────────────────────────────── */
  function renderSlots(config) {
    const tier    = config.tiers[state.tierIdx];
    const colors  = productData.options[0].values; // Color
    const sizes   = productData.options[1].values; // Size
    const wrap    = document.createElement('div');
    wrap.className = 'esb-slots';

    state.slots.forEach((slot, slotIdx) => {
      const slotEl = document.createElement('div');
      slotEl.className = 'esb-slot';

      const title = document.createElement('div');
      title.className = 'esb-slot-title';
      title.textContent = 'Item ' + (slotIdx + 1) + (tier.qty > 1 ? ' of ' + tier.qty : '');
      slotEl.appendChild(title);

      // COLOR
      const colorLbl = document.createElement('div');
      colorLbl.className = 'esb-opt-label';
      colorLbl.textContent = 'Color ';
      if (slot.color) {
        const val = document.createElement('span');
        val.className = 'esb-opt-val';
        val.textContent = slot.color;
        colorLbl.appendChild(val);
      }
      slotEl.appendChild(colorLbl);

      const colorBtns = document.createElement('div');
      colorBtns.className = 'esb-btns';
      colors.forEach(color => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'esb-opt-btn' +
          (slot.color === color ? ' esb-opt-selected' : '');
        btn.textContent = color;
        btn.addEventListener('click', () => {
          state.slots[slotIdx].color = color;
          // Reset size if it's no longer available with new color
          if (state.slots[slotIdx].size) {
            if (!isAvailable(color, state.slots[slotIdx].size)) {
              state.slots[slotIdx].size = null;
            }
          }
          rerender();
        });
        colorBtns.appendChild(btn);
      });
      slotEl.appendChild(colorBtns);

      // SIZE
      const sizeLbl = document.createElement('div');
      sizeLbl.className = 'esb-opt-label';
      sizeLbl.textContent = 'Size ';
      if (slot.size) {
        const val = document.createElement('span');
        val.className = 'esb-opt-val';
        val.textContent = slot.size;
        sizeLbl.appendChild(val);
      }
      slotEl.appendChild(sizeLbl);

      const sizeBtns = document.createElement('div');
      sizeBtns.className = 'esb-btns';
      sizes.forEach(size => {
        const btn = document.createElement('button');
        btn.type = 'button';
        const avail = !slot.color || isAvailable(slot.color, size);
        btn.className = 'esb-opt-btn' +
          (slot.size === size ? ' esb-opt-selected' : '') +
          (!avail ? ' esb-unavail' : '');
        btn.textContent = size;
        if (!avail) btn.disabled = true;
        btn.addEventListener('click', () => {
          state.slots[slotIdx].size = size;
          rerender();
        });
        sizeBtns.appendChild(btn);
      });
      slotEl.appendChild(sizeBtns);

      wrap.appendChild(slotEl);
    });

    return wrap;
  }

  /* ── 9. RENDER FOOTER ─────────────────────────────────────── */
  function renderFooter(config) {
    const wrap = document.createElement('div');
    wrap.className = 'esb-foot';

    const tier     = config.tiers[state.tierIdx];
    const complete = allSlotsComplete();

    const atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'esb-atc';
    atc.disabled = !complete || state.adding;

    if (state.adding) {
      atc.classList.add('esb-adding');
      atc.textContent = 'Adding…';
    } else if (complete) {
      atc.textContent = tier.qty === 1
        ? 'Add to cart — ' + fmt(tier.price)
        : 'Add ' + tier.qty + ' items — ' + fmt(tier.price * tier.qty);
    } else {
      const remaining = state.slots.filter(s => !s.color || !s.size).length;
      atc.textContent = 'Select ' + remaining + ' more item' + (remaining > 1 ? 's' : '');
    }

    atc.addEventListener('click', () => addBundleToCart(config));
    wrap.appendChild(atc);

    const note = document.createElement('div');
    note.className = 'esb-note';
    note.textContent = 'Discounts applied automatically at checkout';
    wrap.appendChild(note);

    return wrap;
  }

  /* ── 10. FULL RENDER ──────────────────────────────────────── */
  function rerender() {
    if (!widgetEl || !currentConfig) return;
    widgetEl.innerHTML = '';

    const head = document.createElement('div');
    head.className = 'esb-head';
    head.textContent = 'Get more, save more';
    widgetEl.appendChild(head);

    widgetEl.appendChild(renderTiers(currentConfig));
    widgetEl.appendChild(renderSlots(currentConfig));
    widgetEl.appendChild(renderFooter(currentConfig));
  }

  /* ── 11. ADD TO CART ──────────────────────────────────────── */
  function addBundleToCart(config) {
    if (state.adding || !allSlotsComplete()) return;

    // Build items array — group identical variants
    const variantCounts = {};
    for (const slot of state.slots) {
      const v = findVariant(slot.color, slot.size);
      if (!v) { alert('One of your selections is no longer available. Please reselect.'); return; }
      variantCounts[v.id] = (variantCounts[v.id] || 0) + 1;
    }

    const items = Object.entries(variantCounts).map(([id, qty]) => ({
      id: parseInt(id),
      quantity: qty
    }));

    state.adding = true;
    rerender();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(r => r.json())
    .then(data => {
      if (data.status) throw new Error(data.description || 'Error');

      state.adding = false;

      // Show success on button
      const atc = widgetEl.querySelector('.esb-atc');
      if (atc) {
        atc.classList.add('esb-done');
        atc.textContent = '✓ Added to cart';
        atc.disabled = true;
      }

      // Open cart drawer via cart-drawer-fix.js mechanism
      fetch('/cart.js')
        .then(r => r.json())
        .then(() => {
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer) {
            const CART_SECTION = 'sections--18685205676095__header_section';
            fetch('/?sections=' + CART_SECTION)
              .then(r => r.json())
              .then(sData => {
                if (sData[CART_SECTION]) {
                  const parser = new DOMParser();
                  const fresh  = parser.parseFromString(sData[CART_SECTION], 'text/html');
                  const fd     = fresh.querySelector('cart-drawer-component');
                  if (fd) drawer.innerHTML = fd.innerHTML;
                }
                setTimeout(() => {
                  const dialog = drawer.querySelector('dialog');
                  if (dialog) {
                    try { dialog.showModal(); } catch(e) { dialog.setAttribute('open', ''); }
                  }
                }, 50);
              });
          }
        });

      // Reset after 3s
      setTimeout(() => {
        state = {
          tierIdx: 1,
          slots: Array.from({ length: config.tiers[1].qty }, () => ({ color: null, size: null })),
          adding: false
        };
        rerender();
      }, 3000);
    })
    .catch(err => {
      state.adding = false;
      rerender();
      console.error('Bundle cart error:', err);
    });
  }

  /* ── 12. INJECT ───────────────────────────────────────────── */
  function injectWidget(config) {
    if (document.getElementById('esb-widget')) return;

    const selectors = [
      '.buy-buttons-block',
      'span.buy-buttons-block',
      '[class*="buy-buttons"]',
      'add-to-cart-component'
    ];
    let anchor = null;
    for (const sel of selectors) {
      anchor = document.querySelector(sel);
      if (anchor) break;
    }
    if (!anchor) return;

    widgetEl = document.createElement('div');
    widgetEl.id = 'esb-widget';
    anchor.parentElement.insertBefore(widgetEl, anchor);

    rerender();
  }

  /* ── 13. INIT ─────────────────────────────────────────────── */
  function init() {
    const type = detectType();
    if (!type) return;

    const config = CONFIGS[type];
    if (!config) return;

    loadProduct().then(product => {
      productData   = product;
      currentConfig = config;

      // Init state with default tier (most popular = index 1)
      const defaultTier = config.tiers[1];
      state.tierIdx = 1;
      state.slots   = Array.from(
        { length: defaultTier.qty },
        () => ({ color: null, size: null })
      );

      injectStyles();
      injectWidget(config);

      if (!document.getElementById('esb-widget')) {
        setTimeout(() => injectWidget(config), 800);
        setTimeout(() => injectWidget(config), 2000);
      }
    }).catch(err => console.error('Essaints bundle: could not load product', err));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
